import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import { socket } from 'api';
import { notify } from 'libs/common';
import { OutlineButton, FilledButton } from 'libs/ui';
import { closeWindow } from 'store/actions/windows';
import { Window } from 'components/shared/window/window';
import { Buttons, Content, Label, TypeSelector } from './settings-sip.styled';

export const SettingsSIP = ({ data }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [sip, setSip] = useState(window.config.sip_number);

  const changeSip = (val) => {
    const out = val.target.value;
    setSip(out);
    window.config.sip_number = out;
  };

  const close = () => {
    dispatch(closeWindow('settingssipwindow'));
  };

  const save = () => {
    socket.call('users.set_sip_number', { number: sip });
    notify(t('widgets.SIP номер'), t('messages.Изменения сохранены'), 'success');
    close();
  };

  const x = window.innerWidth / 2 - 162;

  return (
    <Window width="324px" height="240px" contentHeight="308px" {...data} defaultPosition={{ x, y: 40 }}>
      <Content>
        <TypeSelector>
          <Label>{t('widgets.SIP номер')}</Label>
          <input value={sip} onChange={changeSip} />
        </TypeSelector>
        <Buttons>
          <OutlineButton onClick={close}>{t('buttons.Отменить')}</OutlineButton>
          <FilledButton color="success" onClick={save}>
            {t('buttons.Сохранить')}
          </FilledButton>
        </Buttons>
      </Content>
    </Window>
  );
};
